import { html, rune, View } from 'rune-ts';
import klass from './SolutionSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { SolutionCard } from './SolutionCard';

export class SolutionSection extends View {
  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = {
      solution_title: html.preventEscape(ET('mps2::landing::plus::solution_title')),
      solution_description: html.preventEscape(ET('mps2::landing::plus::solution_description')),
      solution_report: html.preventEscape(ET('mps2::landing::plus::solution_report')),
      solution_store: html.preventEscape(ET('mps2::landing::plus::solution_store')),
      solution_creator: html.preventEscape(ET('mps2::landing::plus::solution_creator')),
      solution_ecommerce: html.preventEscape(ET('mps2::landing::plus::solution_ecommerce')),
      solution_site: html.preventEscape(ET('mps2::landing::plus::solution_site')),
      solution_manage: html.preventEscape(ET('mps2::landing::plus::solution_manage')),
    };

    return html`
      <section class="${klass.container}">
        <div class="${klass.title_wrapper}">
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${texts.solution_title}
          </div>
          <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '14_bold' })}">
            ${texts.solution_description}
          </div>
        </div>
        <div class="${klass.content}">
          ${new SolutionCard({
            title: texts.solution_report,
            imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section7/solution-1.png`,
          })}
          ${new SolutionCard({
            title: texts.solution_store,
            imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section7/solution-2.png`,
          })}
          ${new SolutionCard({
            title: texts.solution_creator,
            imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section7/solution-3.png`,
          })}
          ${new SolutionCard({
            title: texts.solution_ecommerce,
            imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section7/solution-4.png`,
          })}
          ${new SolutionCard({
            title: texts.solution_site,
            imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section7/solution-5.png`,
          })}
          ${new SolutionCard({
            title: texts.solution_manage,
            imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section7/solution-6.png`,
          })}
        </div>
      </section>
    `;
  }
}
